import axios from "axios";

export default {    
    approveEntity(_, params) {
        return axios.post(`/api/approvals/approve/${params.type}`, params.body, {withCredentials: true});
    },
    
    getDocumentsByMetric(_, params) {
        return axios.get(`/api/approvals/get-documents-by-metric-input/${params.type}/${params.input_id}`, {withCredentials: true});
    },

}